import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

import {Button} from "@/components/ui/button";
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter, DialogHeader, DialogTitle
  } from "@/components/ui/dialog";
  import {Input} from "@/components/ui/input";
  import TablesService from "@/services/tables/tables.service";
  import useEventsBus from "@/utils/eventBus";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {onMounted, ref, watch} from "vue";
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'
  import {cn} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";
  import {Check, ChevronsUpDown} from "lucide-vue-next";
  import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover";
  import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList} from "@/components/ui/command";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesEditForm',
  props: {
    object: {},
    parents: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props
  const { emit } = useEventsBus();
  let folder: any = {};
  const parentsOpen = ref(false);
  const formSchema = toTypedSchema(z.object({
    name: z.string(),
    parentId: z.any(),
  }))

  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })

  watch(values, (newFormData) => {
    folder = newFormData;
  });

  const onSubmit = handleSubmit(async () => {
    let res;
    if (!props.object.id) {
      res = await TablesService.createRecord(folder, props.entity);
    } else {
      res = await TablesService.updateRecord(folder, props.entity);
    }
    if (res != undefined) {
      emit('update_'+props.entity, res.data);
    }
  })

  watch(() => props.open, async(_, newValue) => {
    if (newValue === false) {
      if (props.object.id) {
        await initializeForm()
      }
    }
  },{ immediate: true })

  async function initializeForm() {
    const res = await TablesService.getElementById(props.entity, props.object.id);
    if (res?.data) {
      setValues(res.data);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              (!props.object.id)
                ? (_openBlock(), _createBlock(_unref(DialogTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(DialogTitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.edit')), 1)
                    ]),
                    _: 1
                  })),
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "mt-3"
              }, [
                _createVNode(_unref(FormField), { name: "name" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.name')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "parentId" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.parent')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Popover), {
                          open: parentsOpen.value,
                          "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((parentsOpen).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FormControl), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Button), {
                                      variant: "outline",
                                      role: "combobox",
                                      class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).parentId && 'text-muted-foreground'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(values).parentId ? props.parents.find(
                        (parentId) => parentId.id === _unref(values).parentId,
                    )?.name : _unref(i18n).global.t('table.select')) + " ", 1),
                                        _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                                      ]),
                                      _: 1
                                    }, 8, ["class"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Command), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CommandInput), {
                                      placeholder: _ctx.$t('table.search')
                                    }, null, 8, ["placeholder"]),
                                    _createVNode(_unref(CommandEmpty), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(CommandList), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CommandGroup), null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.parents, (parent) => {
                                              return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                key: parent.id,
                                                value: parent.id,
                                                onSelect: () => {
                              _unref(setValues)({
                                parentId: parent.id,
                              })
                              parentsOpen.value = false
                            }
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Check), {
                                                    class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', parent.id === _unref(values).parentId ? 'opacity-100' : 'opacity-0'))
                                                  }, null, 8, ["class"]),
                                                  _createTextVNode(" " + _toDisplayString(`${'- '.repeat(parent.level) }${parent.name}`), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "onSelect"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["open"]),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogFooter), { class: "mt-6" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})